import useYWR, { YWRKey } from "@/features/ui/hooks/use-ywr";
import useFetcher from "@/utils/use-fetcher";

export interface RefreshKreamSaleHistoryParameter {
  kreamProductId: number;
}

export interface RefreshKreamSaleHistoryRequest {}
export interface RefreshKreamSaleHistoryResponse {}

export const refreshKreamSaleHistoryKey: YWRKey<RefreshKreamSaleHistoryParameter> =
  {
    url: ({ kreamProductId }) =>
      `/kream/products/${kreamProductId}/refresh-sale-history`,
    method: "post",
  };

export default function useRefreshKreamSaleHistory() {
  const fetcher = useFetcher<
    RefreshKreamSaleHistoryRequest,
    RefreshKreamSaleHistoryResponse
  >();
  return useYWR(refreshKreamSaleHistoryKey, fetcher);
}
